'use client';
import { useEffect, useState } from 'react';

type Props = {
  value: number;
  className?: string;
};

const AnimatedNumber: FC<Props> = ({ value, className = '' }) => {
  const [displayValue, setDisplayValue] = useState(value);
  const [previousValue, setPreviousValue] = useState(value);

  useEffect(() => {
    const from = previousValue;
    const to = value;
    const duration = 1000;
    const startTime = performance.now();

    const animate = (currentTime: number) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const currentValue = Math.round(from + (to - from) * progress);

      setDisplayValue(currentValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setPreviousValue(to);
      }
    };

    requestAnimationFrame(animate);
  }, [value, previousValue]);

  return (
    <div
      className={`flex font-headline font-medium text-piccolo relative ${className}`}
    >
      <div className="flex items-center">
        <span>$</span>
        <span className="ml-1 tabular-nums" style={{ textAlign: 'left' }}>
          {displayValue.toLocaleString()}
        </span>
      </div>
    </div>
  );
};

export default AnimatedNumber;
